import React from 'react'
import { observer } from 'mobx-react'
import ForEachModel from '../collections/ForEachModel'
import SelectedToCollection from './SelectedToCollection'

function NotSelectedModels (props) {
  return (
    <SelectedToCollection flip>
      <ForEachModel>
        {props.children}
      </ForEachModel>
    </SelectedToCollection>
  )
}

export default observer(NotSelectedModels)
